import useAnalytics from '../hooks/useAnalytics';

/**
 * Route-change tracker. Must be rendered INSIDE <BrowserRouter> because
 * useAnalytics -> useLocation requires router context.
 * Fires Meta Pixel `PageView` and GA `page_view` on every route change
 * (skips the very first render — initial page view is handled by the base
 * Meta Pixel snippet in index.html).
 */
const RouteAnalytics = () => {
  useAnalytics();
  return null;
};

export default RouteAnalytics;
